import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './PolicyPage.css';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-page">
      <div className="policy-hero">
        <div className="container">
          <Link to="/" className="policy-back-link">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
            Back to Home
          </Link>
          <h1 className="policy-page-title">About iLOVEthisGAME</h1>
          <p className="policy-meta">100% Canadian Owned &amp; Operated · Official Canadian Partner of Playermaker</p>
        </div>
      </div>

      <div className="container">
        <div className="policy-body">
          <div className="policy-callout glass-panel" style={{ marginBottom: '3rem' }}>
            <p style={{ fontSize: '1.8rem', fontWeight: '800', color: 'var(--text-primary)', marginBottom: '0.8rem' }}>
              Fueled by Passion, Powered by Grit, Built for the Beautiful Game.
            </p>
            <p style={{ margin: 0 }}>
              Welcome to iLOVEthisGAME, where football (yes, we’re proudly calling it that) is more than a pastime, it’s a way of life. We are 100% Canadian owned and operated, born in Canada and shipping to clubs, teams and leagues from coast to coast. This store was built by players, fans, coaches, and dreamers, for players, fans, coaches, and dreamers.
            </p>
          </div>

          <h2>Football Lives in Our DNA</h2>
          <p>
            For us, football was never just a game. Growing up in Europe, it was part of our DNA. The sound of a ball bouncing off a wall, the muddy cleats after weekend matches, the roar of a neighbourhood celebrating a goal, it was life. We played through our teenage years with fire in our chest and grass stains on our knees. And that love never faded.
          </p>

          <h2>From Pitch to Sidelines</h2>
          <p>
            Now, as parents to kids who live and breathe the sport just like we did, we’ve found ourselves on the sidelines again, this time as a coach, a team manager, and their loudest supporter. We've seen firsthand how football builds character, discipline, and lifelong friendships. It’s not just a sport. It’s a global language. And it pointed us in only one direction, right here, right now.
          </p>

          <h2>Built for Those Who Get It</h2>
          <p>
            At iLOVEthisGAME, we’re building a store for those who get it:
          </p>
          <ul>
            <li>For the kid training under the streetlight</li>
            <li>For the parent cheering rain or shine</li>
            <li>For the coach who knows it’s bigger than winning</li>
            <li>For the Sunday league ballers</li>
          </ul>

          <p>
            We are the go to source for soccer related technology like Playermaker and performance-driven soccer gear for all levels, from grassroots to premier league game day. Whether you’re just lacing up or chasing big dreams, we’ve got what you need to train harder, play smarter, and look good doing it.
          </p>

          <p>
            This isn’t just a store. It’s a celebration of the game we love. So if football lives in your blood too, welcome home and always remember: <strong>Train Smarter. Play Harder.</strong>
          </p>

          <div style={{ marginTop: '4rem', display: 'flex', gap: '1.6rem', flexWrap: 'wrap' }}>
            <Link to="/#product-showcase" className="btn btn-primary" style={{ borderRadius: '9999px', padding: '1.2rem 2.8rem', fontSize: '1.4rem' }}>
              Explore Playermaker 2.0
            </Link>
            <Link to="/contact" className="btn btn-secondary" style={{ borderRadius: '9999px', padding: '1.2rem 2.8rem', fontSize: '1.4rem' }}>
              Contact Our Team
            </Link>
          </div>

          <div className="policy-divider" />
          <p style={{ fontSize: '1.3rem', color: 'var(--text-muted)' }}>iLOVEthisGAME · Official Canadian Partner of Playermaker · British Columbia, Canada</p>
        </div>
      </div>
    </div>
  );
}
